import React from "react";
import {Card} from "@material-ui/core";
import QuestionDetail from "./question_detail/QuestionDetail";

const ResultQuestionList = ({questions, testTypeId}) => {
    return (
        <React.Fragment>
            {questions.map((question, index) => {
                return (
                    <Card square key={question.questionCode} className={"card-detail"}>
                        <QuestionDetail testTypeId={testTypeId} question={question} index={index + 1} disabled={true}/>
                    </Card>
                );
            })}
        </React.Fragment>
    );
};

export default ResultQuestionList;